import React, { useEffect, useMemo } from "react";
import { setDocumentTitle } from "../../services/local/pageTitle";
import {
  buildSuggestedBackofficeHost,
  getBackofficeHostMode,
  getCurrentHostname,
} from "../../services/local/runtimeHost";

const shellBarBaseStyles = {
  width: "100%",
  padding: "10px 18px",
  fontSize: "0.92rem",
  fontWeight: 600,
  letterSpacing: "0.01em",
  boxSizing: "border-box",
};

function BackofficeShell({ children }) {
  const hostMode = useMemo(() => getBackofficeHostMode(), []);
  const currentHostname = useMemo(() => getCurrentHostname(), []);
  const suggestedBackofficeHost = useMemo(
    () => buildSuggestedBackofficeHost(currentHostname),
    [currentHostname]
  );

  useEffect(() => {
    const titlePrefix =
      hostMode === "internal"
        ? "Backoffice"
        : hostMode === "local"
          ? "Backoffice local"
          : "Backoffice vista previa";

    setDocumentTitle(titlePrefix, "Mozzo");
  }, [hostMode]);

  return (
    <>
      {hostMode === "internal" ? (
        <div
          style={{
            ...shellBarBaseStyles,
            backgroundColor: "#0f172a",
            color: "#f8fafc",
            borderBottom: "1px solid rgba(148, 163, 184, 0.25)",
          }}
        >
          {`Backoffice interno MozzoApp${
            currentHostname ? ` | ${currentHostname}` : ""
          }`}
        </div>
      ) : null}

      {hostMode === "preview" ? (
        <div
          style={{
            ...shellBarBaseStyles,
            backgroundColor: "#fff7ed",
            color: "#9a3412",
            borderBottom: "1px solid #fdba74",
          }}
        >
          Vista previa del backoffice en host publico.
          {suggestedBackofficeHost
            ? ` Cuando activemos el subdominio interno, este panel va a vivir en ${suggestedBackofficeHost}.`
            : ""}
        </div>
      ) : null}

      {hostMode === "local" ? (
        <div
          style={{
            ...shellBarBaseStyles,
            backgroundColor: "#eff6ff",
            color: "#1d4ed8",
            borderBottom: "1px solid #93c5fd",
          }}
        >
          Backoffice en modo local para desarrollo y pruebas internas.
        </div>
      ) : null}

      {children}
    </>
  );
}

export default BackofficeShell;
